module.exports = __webpack_public_path__ + "img/shipping.80343c07.svg";